const LOG_DISPATCH = false;
const LOG_GOOGLE_ANALYTICS = false;
const LOG_FUNNEL_ANALYTICS = false;

export {
    LOG_DISPATCH,
    LOG_GOOGLE_ANALYTICS,
    LOG_FUNNEL_ANALYTICS
};
